import { render, staticRenderFns } from "./tr-1.vue?vue&type=template&id=17c45b19&"
import script from "./tr-1.vue?vue&type=script&lang=ts&"
export * from "./tr-1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports